module.exports = [
  {
    title: 'Анализ данных пациента',
    state: 'Analysis',
    permission: 'analysis',
    icon: require('@/assets/icons/Analysis.png')
  },
  {
    title: 'Аналитика',
    state: 'Analytics',
    permission: 'analytics',
    icon: require('@/assets/icons/Analytics.png')
  },
  {
    title: 'Администрирование',
    state: 'Administration',
    permission: 'administration',
    icon: require('@/assets/icons/Administration.png')
  },
  {
    title: 'Прогностическая модель COVID-19',
    state: 'PredictCovid',
    permission: 'predict-covid',
    icon: require('@/assets/icons/PredictCovid.png')
  },
  {
    title: 'Информационная панель COVID-19',
    state: 'DashboardsCovid',
    permission: 'dashboards-covid',
    icon: require('@/assets/icons/DashboardsCovid.png')
  }
]
